<template>
    <el-form :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="100px">
        <el-form-item label="分类名称" prop="name">
            <el-input placeholder="请输入分类名称" v-model="rule.name" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button @click="block">返回</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        data() {
            return {
                name: 'edit',
                rule: {
                    id: 0,
                    name: '',
                },
                rules: {
                    name: {required: true, message: '请输入分类名称'},
                },
            }
        },
        created() {
            if(this.$route.params.id) {
                if(!!this.$store.state.editInfo) {
                    this.rule = this.$store.state.editInfo
                }else {
                    this.$router.push('/warn/type/index');
                }
            }
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        this.$http.post('/manage/alert-type/save',this.rule).then(rs => {
                            if(rs.data.code == 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.$router.push('/warn/type/index');
                            }else {
                                this.$message({
                                    message: rs.data.message,
                                    type: 'error'
                                });
                            }
                        })
                    }
                });
            },
            block() {
                this.$router.go(-1);
            },
        }
    }
</script>